module.exports = __webpack_public_path__ + "models/stake.f8d81896.gltf";